import  { useState, useEffect, useCallback } from 'react';
import { getData, updateData, getpastWebinarYears } from '../../services/webinarEventServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Webinarevent = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  const [form, setForm] = useState({ id: '', event_date: '', event_location: '', event_name: '', theme_name: '', event_date_on: '', event_title: '', year: '' });
  const [pastWebinarYears, setpastWebinarYears] = useState([]);

  // Fetch data
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getData();
      if (data && data.length > 0) {
        setForm(data[0]); // Assuming there's only one record to edit
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const validateForm = () => {
    const newErrors = {};
    // if (!formData.uploadedfile ) {
    //   if (!errors.uploadedfile) newErrors.uploadedfile = "Slider is required";
    // }
  if (!form.event_date) newErrors.event_date = "Event Date is required";
  if (!form.event_location) newErrors.event_location = "Event Location is required";
  if (!form.event_name) newErrors.event_name = "Event Name is required";
  if (!form.theme_name) newErrors.theme_name = "Theme Name is required";
  if (!form.event_date_on) newErrors.event_date_on = "Event Date On is required";
  if (!form.event_title) newErrors.event_title = "Event Title is required";
  if (!form.year) newErrors.year = "Year is required";

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

  useEffect(() => {
      const fetchpastWebinarYears = async () => {
        try {
          const data = await getpastWebinarYears(); // Fetch data from the service
          setpastWebinarYears(data); // Set the types in state
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
   
      fetchpastWebinarYears();
    }, []);
  

  // Handle input change
  const handleChange = (e) => {
    try{
    const { name, value } = e.target;
    let updatedErrors = { ...errors };
    if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
        }
    setErrors(updatedErrors);
    setForm((prev) => ({ ...prev, [name]: value }));
    }
    catch(error){
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission (update details)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try {
      await updateData(form);
      fetchData(); // Refresh data after update
      toast.success("Saved Successfully!", {
                    position: 'top-right',
                    autoClose: 3000,
                  });

    } catch (error) {
      toast.error("Failed to update data. Please try again.", {
                position: 'top-right',
                });
      console.error('Error updating data:', error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Event Pages / Webinar <b>/ Webinar Details</b></p>
            </div>
          </div>
          <Form>
          <div className="row">
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Event Title <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="event_title"
                value={form.event_title}
                onChange={handleChange}
                isInvalid={!!errors.event_title}
              />
              <Form.Control.Feedback type="invalid">{errors.event_title}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-6 mb-3">
              <Form.Label className='form-label-custom'>Event Name <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="event_name"
                value={form.event_name}
                onChange={handleChange}
                isInvalid={!!errors.event_name}
              />
              <Form.Control.Feedback type="invalid">{errors.event_name}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-3 mb-3">
              <Form.Label className='form-label-custom'>Webinar Date <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="event_date"
                value={form.event_date}
                onChange={handleChange}
                isInvalid={!!errors.event_date}
              />
              <Form.Control.Feedback type="invalid">{errors.event_date}</Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group className="col-md-3 mb-3">
              <Form.Label>Event Location</Form.Label>
              <Form.Control
                type="text"
                name="event_location"
                value={form.event_location}
                onChange={handleChange}
              />
            </Form.Group> */}
            
            <Form.Group className="col-md-3 mb-3">
              <Form.Label className='form-label-custom'>Webinar Theme <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="text"
                name="theme_name"
                value={form.theme_name}
                onChange={handleChange}
                isInvalid={!!errors.theme_name}
              />
              <Form.Control.Feedback type="invalid">{errors.theme_name}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-3 mb-3">
              <Form.Label className='form-label-custom'>Timer date <small className='text-danger'> * </small></Form.Label>
              <Form.Control
                type="date"
                name="event_date_on"
                value={form.event_date_on}
                onChange={handleChange}
                isInvalid={!!errors.event_date_on}
              />
              <Form.Control.Feedback type="invalid">{errors.event_date_on}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="col-md-3 mb-3">
            <Form.Label className='form-label-custom'>Past Webinar Year <small className='text-danger'> * </small></Form.Label>
            <Form.Control className="form-select mb-3" as="select" name="year" value={form.year} onChange={handleChange} isInvalid={!!errors.year} >
                <option value="">Select Year</option>
                {pastWebinarYears.map((years) => (
                    <option key={years.year} value={years.year}>
                    {years.display_year}
                    </option>
                ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">{errors.year}</Form.Control.Feedback>
            </Form.Group>
            </div>
            <Button variant="success" onClick={handleSubmit}>Submit</Button>          
          </Form>
        </div>
        <Footer />
         </div>
        )}
      </div>
    </div>
  );
};

export default Webinarevent;
